// KWANKGM03140_住宅ローンしっかり審査事前審査申込入力（受付完了）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import HeadingM from '../../molecules/HeadingM';
import ApplicationInformation from '../../molecules/ApplicationInformation';
import MypageReturn from '../../molecules/MypageReturn';
import Paragraph from '../../molecules/Paragraph';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  opened_mypage: boolean;
  ja_name: string;
  is_staff: boolean;
  display_status: boolean;
}

const PreExaminationHousingLoanFirmlyFinish: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  ja_name,
  display_status,
  opened_mypage,
  is_staff,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <HeadingM label="事前審査お申込み完了"></HeadingM>
      <div className="p-lead">
        お客様のお申込みを受け付けました。
        <br />
        ご登録のメールアドレスに事前審査受付メールを送信しました。
        <br />
        メールが届かない場合には申込先JAにお問合せ下さい。連絡先の電話番号はJAバンクホームページからご確認下さい。
        <br />
        お問合せの際には申込番号が必要です。
      </div>
      <ApplicationInformation ja_name={ja_name} reception_cd={reception_cd} />
      {/*『マイページへ戻る』ボタンを表示*/}
      {opened_mypage && <MypageReturn is_staff={is_staff} />}
    </>
  );
};

export default PreExaminationHousingLoanFirmlyFinish;
